import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  nationalities: []
}

// getters
export const getters = {
  nationalities: state => state.nationalities
}

// mutations
export const mutations = {
  [types.FETCH_NATIONALITIES_SUCCESS] (state, { nationalities }) {
    state.nationalities = nationalities
  },

  [types.FETCH_NATIONALITIES_FAILURE] (state) {
    state.NATIONALITIES = []
  }
}

// actions
export const actions = {
  async fetchNationalities ({ commit }) {
    try {
      const response = await axios.get(`/api/nationalities`)

      commit(types.FETCH_NATIONALITIES_SUCCESS, { nationalities: response.data })
    } catch (error) {
      console.error(error)
      commit(types.FETCH_NATIONALITIES_FAILURE)
    }
  }
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/nationalities.js